import { BetHistoryEntitySelection } from '@/common/api/model';

export type SelectedBetEvent = {
  eventId: string;
  marketId: string;
  outcomeId: string;
};

/**
 * Extracts selected bet events from metadata when SELECTED_ENTITY_TYPE is 'BET'
 * Falls back to first selection if __USER_EVENTS is empty/null
 * @param metadata - The metadata object containing bet selection data
 * @returns Array of SelectedBetEvent or undefined if not applicable
 */
export const extractSelectedBetEvents = (metadata?: Record<string, any>): SelectedBetEvent[] | undefined => {
  if (!metadata) return undefined;

  const isBetEntityType = metadata.SELECTED_ENTITY_TYPE === 'BET';
  if (!isBetEntityType) return undefined;

  const userEvents = metadata.__USER_EVENTS as BetHistoryEntitySelection[] | undefined;
  const selections = metadata.selections as BetHistoryEntitySelection[] | undefined;

  // Use __USER_EVENTS if available, otherwise fallback to first item in selections
  const eventsToMap = userEvents?.length ? userEvents : selections?.length ? [selections[0]] : undefined;

  if (!eventsToMap?.length) return undefined;

  return eventsToMap.map((event) => ({
    // Post process eventId
    eventId: `${event.eventId}`.replace('sr:match:', ''),
    marketId: event.marketId,
    outcomeId: event.outcomeId,
  }));
};
